export const EMIT_NOTIFICATION = 'EMIT_NOTIFICATION'

export const SET_NOTIFICATION_PERMISSION = 'SET_NOTIFICATION_PERMISSION'
